import * as types from "../constants/actionTypes";
import * as Rx from "rxjs";
import * as mouseFlowUtils from "../utils/mouseFlowUtils";
import * as actions from "../actions/workOrderActions";
import {
  TAG_CLOSE_ORDER,
  TAG_ADDRESSABLE_HIT,
  TAG_REFRESH_HIT,
  TAG_FETCH_WORK_ORDER
} from "../constants/mouseFlow";
import { concat } from "rxjs/observable/concat";
const apiUrls = require("../constants/apiUrls");
const { Observable } = Rx;
const { of, ajax } = Observable;
import { wowCustomHeader, getCommonHeaders } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';
import log from 'utils/logger';

const routeLogger = log('getTechRouteEpic');

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {
  getWorkOrderDetail: (request, config, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    if (!accessToken) {
      throw `Token was not found.`;
    }

    let body = null;

    if (config.method === "POST") {
      body = config.buildPostRequest(request);
    }

    const wowHeaders = wowCustomHeader(state);

    mouseFlowUtils.setOrderId(request.orderId);
    mouseFlowUtils.setTag(TAG_FETCH_WORK_ORDER);

    return ajax({
      url: config.getApiUrl(request),
      method: config.method,
      body: body,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + accessToken
      }
    });
  },
  getHomeVerify: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = `${apiUrls.GET_HOME_VERIFY_URL}/${request}`;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },
  setHomeVerify: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = apiUrls.SET_HOME_VERIFY_URL;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: "post",
      responseType: "json",
      body: request,
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + accessToken
      }
    });
  },
  getTechRoute: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    if (!accessToken) {
      throw new Error("Token was not found.");
    }

    // Always resolve by explicit userId (WORKORDER_TECH_ROUTE_URL), even for a tech's own
    // route. WORKORDER_MY_ROUTE_URL infers identity from the JWT's tech_id claim, which the
    // backend matches against AD's TechId attribute with no fallback — if that claim has
    // drifted out of sync with AD (stale token, HR/ICOMS sync gap), it silently returns an
    // empty route. The userId-based lookup instead matches AD's live SamAccountName field,
    // which is what a supervisor's lookup of the same tech already relies on successfully.
    const url = `${apiUrls.WORKORDER_TECH_ROUTE_URL}?userId=${request.userId}`;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },

  getMyRoute: (store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    if (!accessToken) {
      throw `Token was not found.`;
    }

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.WORKORDER_MY_ROUTE_URL,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },

  getDigitalChannelsByMarketId: (marketId, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = apiUrls.GET_DIGITAL_CHANNELS_URL + '/' + marketId;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },

  getWorkOrderByOrderId: (orderId, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = apiUrls.WORK_ORDER_BY_ORDER_ID_URL;

    const wowHeaders = wowCustomHeader(state);

    mouseFlowUtils.setOrderId(orderId);

    return ajax({
      url: `${url}?serviceOrderId=${orderId}`,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },
  getWorkOrderHistoryByAddressId: (addressId, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = apiUrls.WORKORDER_HISTORY;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: `${url}?addressId=${addressId}`,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },
  getWorkOrderHistoryByTechId: (techId, startDate, endDate, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = `${apiUrls.TECH_GET_HISTORY_URL}?techId=${techId}&startDate=${startDate}&endDate=${endDate}`;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: "get",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + accessToken
      }
    });
  },
  addCloseOrderRequest: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const userId = state.getIn(['user', "userId"]);

    const wowHeaders = wowCustomHeader(state);

    request.username = userId;

    if (request.ticketRequests) {
      request.ticketRequests.forEach(ticketRequest => {
        ticketRequest.username = userId;
      });
    }

    return ajax({
      url: apiUrls.CLOSE_REQUEST_ADD_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + accessToken
      }
    });
  },
  closeOrder: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    mouseFlowUtils.setOrderId(request.orderId);
    mouseFlowUtils.setNewPageView(apiUrls.CLOSE_ORDER_START_URL);
    mouseFlowUtils.setTag(TAG_CLOSE_ORDER);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.CLOSE_ORDER_START_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + accessToken
      }
    });
  },
  sendHit: (request, store, orderId) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);

    const billingSystem = state
      .getIn([
        "workOrder",
        "workOrderDetails",
        orderId,
        "schedulingSystemDetails",
        "details",
        "billingSystem"
      ]);

    const wowHeaders = wowCustomHeader(state);

    request.billingSystem = billingSystem;
    mouseFlowUtils.setOrderId(orderId);
    mouseFlowUtils.setNewPageView(apiUrls.EQUIPMENT_HIT_URL);
    mouseFlowUtils.setTag(TAG_ADDRESSABLE_HIT);

    return ajax({
      url: apiUrls.EQUIPMENT_HIT_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + token
      }
    });
  },
  sendBalancingHit: (request, store, orderId) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);

    const schedulingSystemDetails = state
      .getIn([
        "workOrder",
        "workOrderDetails",
        orderId,
        "schedulingSystemDetails",
        "details"
      ]);

    const wowHeaders = wowCustomHeader(state);

    const billingSystem = schedulingSystemDetails.get("billingSystem");
    const techId = schedulingSystemDetails.get("technicianId");

    request.billingSystem = billingSystem;
    request.techId = techId;
    request.userId = state.getIn(['user', "userId"]);

    return ajax({
      url: apiUrls.EQUIPMENT_BALANCING_HIT_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + token
      }
    });
  },
  sendRefreshHit: (request, store, orderId) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);

    const billingSystem = state
      .getIn([
        "workOrder",
        "workOrderDetails",
        orderId,
        "schedulingSystemDetails",
        "details",
        "billingSystem"
      ]);

    const wowHeaders = wowCustomHeader(state);

    request.billingSystem = billingSystem;
    mouseFlowUtils.setOrderId(orderId);
    mouseFlowUtils.setNewPageView(apiUrls.EQUIPMENT_REFRESH_HIT_URL);
    mouseFlowUtils.setTag(TAG_REFRESH_HIT);

    return ajax({
      url: apiUrls.EQUIPMENT_REFRESH_HIT_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + token
      }
    });
  },
  unpairPair: (request, store) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.UNPAIR_PAIR_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + token
      }
    });
  },
  updateTags: (request, store) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.TAG_UPDATE_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: "Bearer " + token
      }
    });
  },

  outletUpdateAppian: (action, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    const apiUrl = `${apiUrls.EQUIPMENT_DETAIL_URL}?billingSystem=Icoms&accountNumber=${action.accountNumber}&orderNumber=${action.orderId}`;

    return ajax({
      url: apiUrl,
      method: "GET",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + accessToken
      }
    });
  },

  outletUpdate: (action, store) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);


    const schedulingSystemDetails = state.getIn([
      "workOrder",
      "workOrderDetails",
      action.orderId,
      "schedulingSystemDetails",
      "details"
    ]);

    const customerDetails = state.getIn([
      "workOrder",
      "workOrderDetails",
      action.orderId,
      "customerDetails",
      "details"
    ]);

    const authenticationKey = state.getIn(["message", "appianGrantChannelAuthKey"]);

    const wowHeaders = wowCustomHeader(state);
    const orderNumber = action.orderId;
    const billingSystem = schedulingSystemDetails.get("billingSystem");
    const techId = schedulingSystemDetails.get("technicianId");
    const accountNumber = customerDetails.get("accountNumber");

    mouseFlowUtils.setOrderId(orderNumber);
    mouseFlowUtils.setNewPageView(apiUrls.EQUIPMENT_DETAIL_URL);

    const request = {
      outletUpdates: action.request,
      accountNumber,
      orderNumber,
      billingSystem,
      techId
    };

    return ajax({
      url: apiUrls.EQUIPMENT_DETAIL_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
        authenticationKey: authenticationKey
      }
    });
  },
  updateCustomerEmail: (request, store, orderID, isLoginEmail = false) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);
    const wowHeaders = wowCustomHeader(state);

    if (isLoginEmail) {
      const ajaxRequestOptons = {
        url: apiUrls.UPDATE_EMAIL_CIC,
        method: 'POST',
        responseType: "json",
        crossDomain: true,
        timeout: apiUrls.API_TIMEOUT,
        headers: {
          ...wowHeaders,
          "Content-Type": "application/json",
          authorization: "Bearer " + accessToken
        }
      };

      ajaxRequestOptons.body = {
        userUid: request.userUid,
        newLoginEmail: request.newLoginEmail,
        ecid: request.ecid
      };

      return ajax(ajaxRequestOptons);
    } else {

      const requestUrl = apiUrls.UPDATE_CUSTOMER_EMAIL_URL;

      const methodType = 'POST';

      // todo -> this broke email update for CE's MAC address uppercase fix...
      // the reason is that the WOW-API-GATEWAY project doesn't accept these headers yet.
      // We need to fix the API gateway project to accept these headers with the CORS stuff.
      //const wowHeaders = wowCustomHeader(state);

      const finalRequest = {
        accountNumber: request.accountNumber,
        billingSystemType: request.billingSystemType,
        emailAddress: request.emailAddress,
        userUid: request.userUid,
        ecid: request.ecid
      };

      if (request.comment === "null") {
        request.comment = null;
      }

      const ajaxRequestOptons = {
        url: requestUrl,
        method: methodType,
        responseType: "json",
        crossDomain: true,
        timeout: apiUrls.API_TIMEOUT,
        headers: {
          // ...wowHeaders,
          "Content-Type": "application/json",
          authorization: "Bearer " + accessToken
        }
      };

      ajaxRequestOptons.body = finalRequest;

      return ajax(ajaxRequestOptons);
    }
  },
  getAddressFromBiller: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const url = `${apiUrls.WORKORDER_CUSTOMER_ADDRESS_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}`;

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: url,
      method: "GET",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + accessToken
      }
    });
  },
  pinReset: (store, request) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    //const wowHeaders = wowCustomHeader(state);

    const headers = {
      // ...wowHeaders,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    };

    return ajax({
      url: apiUrls.PIN_RESET_URL,
      method: "post",
      body: request,
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers
    });
  },
  deliveryProof: (request, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.SET_DELIVERY_PROOF_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": 'application/json',
        authorization: "Bearer " + accessToken
      }
    });
  },
  sendAsurionPlusEnrollment: (request, store) => {
    return ajax({
      url: apiUrls.SEND_ASURION_PLUS_ENROLLMENT,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...getCommonHeaders(store),
      }
    });
  },
  getNoAccessReasonList: (store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);
    return ajax({
      url: apiUrls.UNABLE_CLOSE_REASONS_URL,
      method: "GET",
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": 'application/json',
        authorization: "Bearer " + accessToken
      }
    });
  },
  addEquipmentBySerialNumber: (action, store) => {
    const state = store.getState();
    const token = getAccessTokenFromState(state);

    const authenticationKey = state.getIn(["message", "appianGrantChannelAuthKey"]);

    const wowHeaders = wowCustomHeader(state);
    mouseFlowUtils.setOrderId(action.orderId);
    mouseFlowUtils.setNewPageView(apiUrls.EQUIPMENT_ADD_BY_SERIAL_URL);

    const request = action.payload;

    return ajax({
      url: apiUrls.EQUIPMENT_ADD_BY_SERIAL_URL,
      method: "POST",
      body: request,
      responseType: "json",
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
        authenticationKey: authenticationKey
      }
    });
  },
  transferWorkOrder: (action, store) => {
    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    const request = {
      WorkOrderNumber: action.orderId,
      ToTechId: action.techId,
    }

    return ajax({
      url: apiUrls.WORK_ORDER_TRANSFER_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + accessToken,
      }
    });
  }
};

export const getWorkOrderDetailEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.WORK_ORDER_GET_STARTED).mergeMap(action =>
    call(api.getWorkOrderDetail, action.request, action.config, store)
      .map(payload => {
        return actions.getWorkOrderFinished(
          payload.response,
          action.config.key,
          action.request.orderId
        );
      })
      .catch(error => {
        // this will allow the order card to load even if the customer account details are not found.
        if (error.status === 404 && action.config.key === 'customerDetails') {
          return of(
            actions.getWorkOrderFinished(
              {},
              action.config.key,
              action.request.orderId
            )
          );
        }

        return of(
          actions.getWorkOrderFailed(
            error,
            action.config.key,
            action.request.orderId
          )
        );
      }
      )
  );

export const getTechRouteEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.WORK_ORDER_GET_TECH_ROUTE_STARTED).mergeMap(action => {
    const state = store.getState();
    const techEmail = state.getIn(['user', 'userId']);
    const techIdHeader = state.getIn(['techData', 'techs', techEmail, 'info', 'techId']) || null;

    routeLogger.warn({
      category: 'route-request-diagnostic',
      userId: action.request.userId,
      isSelf: action.request.isSelf,
      techIdHeader,
    });

    const buildFinishedAction = (payload) => {
      const response = payload.response;
      const assignedOrders = (response && response.assignedServiceOrders) || [];
      const technicianIdsInResponse = [...new Set(assignedOrders.map(o => o.technicianId))];
      const userIdRequested = action.request.userId;

      routeLogger.warn({
        category: 'route-response-diagnostic',
        userId: userIdRequested,
        isSelf: action.request.isSelf,
        orderCount: assignedOrders.length,
        technicianIdsInResponse,
        userIdFoundInResponse: technicianIdsInResponse.includes(userIdRequested),
      });

      return actions.workOrderGetTechRouteFinished(
        response,
        userIdRequested
      );
    };

    return call(api.getTechRoute, action.request, store)
      .map(buildFinishedAction)
      .catch(error => {
        if (action.request.isSelf && error && error.status === 403) {
          // Logged at info, not warn: until the techRoute entitlement gate is loosened to
          // allow self-lookups, this 403 -> myRoute fallback is the routine path for every
          // non-admin tech's own route load, not an anomaly - keeping it off the warn/error
          // stream avoids drowning out real signal in the same Datadog queries used to
          // investigate actual route/status issues.
          routeLogger.info({
            category: 'route-response-fallback',
            userId: action.request.userId,
            isSelf: action.request.isSelf,
            reason: 'techRoute403RetryMyRoute'
          });

          return call(api.getMyRoute, store)
            .map(buildFinishedAction)
            .catch(fallbackError => {
              routeLogger.warn({
                category: 'route-response-diagnostic',
                userId: action.request.userId,
                isSelf: action.request.isSelf,
                error: fallbackError && fallbackError.message,
                status: fallbackError && fallbackError.status,
                reason: 'techRoute403RetryMyRouteFailed'
              });
              return of(actions.workOrderGetTechRouteFailed(fallbackError, action.request.userId));
            });
        }

        routeLogger.warn({
          category: 'route-response-diagnostic',
          userId: action.request.userId,
          isSelf: action.request.isSelf,
          error: error && error.message,
          status: error && error.status,
        });
        return of(actions.workOrderGetTechRouteFailed(error, action.request.userId));
      })
      // Wrap the whole chain - including the 403→MyRoute fallback - so a newer route request
      // (e.g. a nav-away-and-back, or monitoringMiddleware's periodic refresh) cancels a
      // still-in-flight fallback instead of letting it land late and overwrite fresher data.
      .takeUntil(action$.ofType(types.WORK_ORDER_GET_TECH_ROUTE_STARTED));
  });


export const getDigitalChannelsEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.GET_DIGITAL_CHANNELS_STARTED).mergeMap(action =>
    call(api.getDigitalChannelsByMarketId, action.marketId, store)
      .map(payload => {
        return actions.getDigitalChannelsFinished(payload.response, action.orderId);
      })
      .catch(error =>
        of(actions.getDigitalChannelsFailed(error, action.orderId))
      )
  );

export const getWorkOrderByIdEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.WORK_ORDER_BY_ORDER_ID_GET_STARTED).mergeMap(action =>
    call(api.getWorkOrderByOrderId, action.orderId, store)
      .map(payload => {
        return actions.workOrderByOrderIdGetFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error =>
        of(actions.workOrderByOrderIdGetFailed(error, action.orderId))
      )
  );

export const getWorkOrderHistoryByAddressIdEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.ORDER_HISTORY_REQUEST_STARTED).mergeMap(action =>
    call(api.getWorkOrderHistoryByAddressId, action.request.addressId, store)
      .map(payload => {
        return actions.getOrderHistoryFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error => of(actions.getOrderHistoryFailed(error, action.orderId)))
  );

export const getWorkOrderHistoryByTechIdEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.TECH_HISTORY_REQUEST_STARTED).mergeMap(action =>
    call(
      api.getWorkOrderHistoryByTechId,
      action.techId,
      action.startDate,
      action.endDate,
      store
    )
      .map(payload => {
        return actions.getTechHistoryFinished(payload.response, action.techId);
      })
      .catch(error => of(actions.getTechHistoryFailed(error, action.techId)))
  );

export const addCloseRequestEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.ORDER_CLOSE_REQUEST_ADD_STARTED).mergeMap(action =>
    call(api.addCloseOrderRequest, action.request, store)
      .map(payload => {
        return actions.orderCloseRequestAddFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error =>
        of(actions.orderCloseRequestAddFailed(error, action.orderId))
      )
  );

export const startOrderCloseEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.ORDER_CLOSE_STARTED).mergeMap(action =>
    call(api.closeOrder, action.request, store)
      .map(payload => {
        return actions.orderCloseWaiting(payload.response, action.orderId);
      })
      .catch(error => of(actions.orderCloseFailed(error, action.orderId)))
  );

export const sendHitEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.EQUIPMENT_HIT_STARTED).mergeMap(action =>
    call(api.sendHit, action.request, store, action.orderId)
      .map(payload => {
        return actions.equipmentHitFinished(
          payload.response,
          action.request,
          action.orderId
        );
      })
      .catch(error =>
        of(actions.equipmentHitFailed(error, action.request, action.orderId))
      )
  );

export const sendBalancingHitEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.EQUIPMENT_BALANCING_HIT_STARTED).mergeMap(action =>
    call(api.sendBalancingHit, action.request, store, action.orderId)
      .map(payload => {
        return actions.equipmentBalancingHitFinished(
          payload.response,
          action.request,
          action.orderId
        );
      })
      .catch(error =>
        of(
          actions.equipmentBalancingHitFailed(
            error,
            action.request,
            action.orderId
          )
        )
      )
  );

export const sendRefreshHitEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.EQUIPMENT_REFRESH_HIT_STARTED).mergeMap(action =>
    call(api.sendRefreshHit, action.request, store, action.orderId)
      .map(payload => {
        return actions.equipmentRefreshHitFinished(
          payload.response,
          action.request,
          action.orderId
        );
      })
      .catch(error =>
        of(
          actions.equipmentRefreshHitFailed(
            error,
            action.request,
            action.orderId
          )
        )
      )
  );

export const updateTagsEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.TAG_UPDATE_STARTED).mergeMap(action =>
    call(api.updateTags, action.request, store)
      .map(payload => {
        return actions.tagUpdateFinished(payload.response, action.orderId);
      })
      .catch(error => of(actions.tagUpdateFailed(error, action.orderId)))
  );

export const outletUpdateAppianEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.OUTLET_UPDATE_APPIAN_STARTED).mergeMap(action =>
    call(api.outletUpdateAppian, action, store)
      .map(payload => {
        return actions.outletUpdateAppianFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error => of(actions.outletUpdateAppianFailed(error, action.orderId)))
  );

export const outletUpdateEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.OUTLET_UPDATE_STARTED).mergeMap(action =>
    call(api.outletUpdate, action, store)
      .map(payload => {
        console.log('[FST] outletUpdateEpic: raw response for orderId=%s', action.orderId, payload.response);

        const requestOutlets = action.request;
        const outletUpdates = (payload.response.outletUpdates || []).map(responseOutlet => {
          const requestOutlet = requestOutlets.find(
            req => req.get('equipmentOutlet') === responseOutlet.equipmentOutlet
          );
          return {
            ...responseOutlet,
            action: requestOutlet ? requestOutlet.get('action') : responseOutlet.action,
            seriaNumber: responseOutlet.seriaNumber || (requestOutlet ? requestOutlet.get('seriaNumber') : null)
          };
        });

        console.log('[FST] outletUpdateEpic: merged outletUpdates', outletUpdates);

        const response = {
          ...payload.response,
          outletUpdates,
          isSelf: action.isSelf
        };

        return actions.outletUpdateFinished(response, action.orderId, action.userId);
      })
      .catch(error => of(actions.outletUpdateFailed(error, action.orderId)))
  );

export const sendUnpairPairEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.UNPAIR_PAIR_STARTED).mergeMap(action =>
    call(api.unpairPair, action.request, store)
      .map(payload => {
        return actions.unpairPairFinished(
          payload.response,
          action.request,
          action.orderId
        );
      })
      .catch(error =>
        of(actions.unpairPairFailed(error, action.request, action.orderId))
      )
  );


export const updateCustomerEmailEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.UPDATE_CUSTOMER_EMAIL_STARTED).mergeMap(action =>
    call(api.updateCustomerEmail, action.request, store, action.orderId, action.isLoginEmail)
      .map(data => {
        return actions.updateCustomerEmailFinished(
          data.response,
          action.orderId,
          action.isLoginEmail
        );
      })
      .catch(error => {
        if (error.status === 401) {
          return concat(
            of(actions.updateCustomerEmailFailed(error.response, error.status, action.orderId, action.isLoginEmail)),
            // TODO: how to refresh oidc token programatically?
          );
        }

        return of(actions.updateCustomerEmailFailed(error.response, error.status, action.orderId, action.isLoginEmail));
      })
  );



export const getAddressFromBillerEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.GET_ADDRESS_FROM_BILLER_STARTED).mergeMap(action =>
    call(api.getAddressFromBiller, action.request, store, action.orderId)
      .map(payload => {
        return actions.getAddressFromBillerFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(() =>
        of(actions.getAddressFromBillerFailed(action.payload, action.orderId))
      )
  );

export const getHomeVerifyEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.GET_HOME_VERIFY_STARTED).mergeMap(action =>
    call(api.getHomeVerify, action.request, store)
      .map(payload => {
        return actions.getHomeVerifyFinished(
          payload.response, action.request
        );
      })
      .catch(error =>
        of(actions.getHomeVerifyFailed(error, action.request))
      )
  );

export const setHomeVerifyEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.SET_HOME_VERIFY_STARTED).mergeMap(action =>
    call(api.setHomeVerify, action.request, store)
      .map(payload => {
        return actions.getHomeVerifyStarted(
          action.request.serviceOrder
        );
      })
      .catch(error =>
        of(actions.setHomeVerifyFailed(error, action.request))
      )
  );

export const pinResetEpic = (action$, store, call = indirect.call) =>
  action$
    .ofType(types.PIN_RESET_STARTED)
    .mergeMap(action =>
      call(api.pinReset, store, action.request)
        .map(payload =>
          actions.pinResetFinished(
            action.orderId,
            payload.response,
            action.request && action.request.pinType
          )
        )
        .catch(error => {
          if (error.status === 401) {
            return concat(
              of(actions.pinResetFailed(
                action.orderId,
                error.response,
                action.request && action.request.pinType
              )),
              // TODO: how to refresh oidc token programatically?
            );
          }

          return of(actions.pinResetFailed(
            action.orderId, error.response,
            action.request && action.request.pinType
          ));
        })
    );

export const deliveryProofEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.DELIVERY_PROOF_SUBMIT_STARTED).mergeMap(action =>
    call(api.deliveryProof, action.request, store)
      .map(payload => {
        return actions.deliveryProofSubmitFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error =>
        of(actions.deliveryProofSubmitFailed(error, action.orderId))
      )
  );

export const asurionPlusEnrollmentEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.ASURION_PLUS_ENROLLMENT_SUBMIT_STARTED).mergeMap(action =>
    call(api.sendAsurionPlusEnrollment, action.request, store)
      .map(payload => {
        return actions.asurionPlusEnrollmentSubmitFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error => {
        return of(actions.asurionPlusEnrollmentSubmitFailed(error.response || error, action.orderId));
      })
  );

export const getNoAccessReasonListEpic = (
  action$,
  store,
  call = indirect.call
) =>
  action$.ofType(types.GET_NOACCESS_REASONS_STARTED).mergeMap(action =>
    call(api.getNoAccessReasonList, store)
      .map(payload => {
        return actions.getNoAccessReasonListFinished(
          payload.response,
          action.orderId
        );
      })
      .catch(error =>
        of(actions.getNoAccessReasonListFailed(error, action.orderId))
      )
  );

export const addEquipmentBySerialNumberEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.EQUIPMENT_ADD_BY_SERIAL_STARTED).mergeMap(action =>
    call(api.addEquipmentBySerialNumber, action, store)
      .map(payload => {
        return actions.addEquipmentBySerialFinished(payload.response, action.path, action.orderId);
      })
      .catch(error => of(actions.addEquipmentBySerialFailed(error, action.path, action.orderId)))
  );

export const transferWorkOrderEpic = (action$, store, call = indirect.call) =>
  action$.ofType(types.TECH_WORK_ORDER_TRANSFER_STARTED).mergeMap(action =>
    call(api.transferWorkOrder, action, store)
      .map(payload => {
        return actions.transferWorkOrderFinished(payload.response, action.orderId);
      })
      .catch(error => of(actions.transferWorkOrderFailed(error, action.orderId)))
  );


// WEBPACK FOOTER //
// ./src/epics/workOrderEpics.js